import { useEffect } from "react";
import { useTranslation } from "react-i18next";

/**
 * Sets the browser tab title to "<title> – <appTitle>", or the app title
 * alone. The static <title> in index.html is the boot fallback before React
 * mounts. Rationale for hook vs. router head(): decisions-log 2026-06-13.
 */
export function useDocumentTitle(title?: string): void {
  const { t } = useTranslation("common");
  const appTitle = t("appTitle");

  useEffect(() => {
    document.title = title ? `${title} – ${appTitle}` : appTitle;
  }, [title, appTitle]);
}
